import { Link } from '@inertiajs/react';
import { Button } from '../../design-system/components';
export default function Error500() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-secondary px-4">
      <div className="text-center">
        <p className="text-6xl font-bold text-danger-600">500</p>
        <h1 className="mt-4 text-2xl font-semibold text-fg">Something Went Wrong</h1>
        <p className="mt-2 text-fg-secondary">
          We&apos;re experiencing an internal error. Please try again later or contact support if
          the problem persists.
        </p>
        <div className="mt-8 flex items-center justify-center gap-4">
          <Button variant="outline" onClick={() => window.location.reload()}>
            Try Again
          </Button>
          <Link href="/">
            <Button>Go Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
